import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./styles/global.css";
import Header from "./components/Header";
import HomePage from "./pages/HomePage/HomePage";
import Footer from "./components/Footer";
import SignUpPage from "./pages/signUp/SignUp";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PrivacyPolicyPage from "./pages/PolicyPage/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/PolicyPage/CookiePolicyPage";
import { useMediaQuery } from "react-responsive";
import ServicePage from "./pages/ServicePage/ServicePage";
import ServiceHeader from "./components/ServiceHeader";
import ServiceMenu from "./components/ServiceMenu";
import ShopPage from "./pages/ShopPage/ShopPage";
import ServiceFooter from "./components/ServiceFooter";
import Button from "./components/common/Button";
import { loadProducts } from "./backend/shop/product";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import { loadPatronat } from "./backend/services/caseCatergories";
import { loadPatronatInfo } from "./backend/info/patronatInfo";
import { loadMainInfo } from "./backend/info/mainInfo";
import { loadHowToHelp } from "./backend/howToHelp/howToHelp";
import { loadProPolk } from "./backend/proPolk/proPolk";
import LandingPage from "./pages/LandingPage.tsx/LandingPage";
import LandingHeader from "./components/LandingHeader";
import LandingFooter from "./components/LandingFooter";
import AdminAdvantage from "./admin/pages/admin/AdminAdvantage";
import AdminAnketa from "./admin/pages/admin/AdminAnketa";
import AdminBattleHistory from "./admin/pages/admin/AdminBattleHistory";
import AdminChangePassword from "./admin/pages/admin/AdminChangePassword";
import AdminHowToHelp from "./admin/pages/admin/AdminHowToHelp";
import AdminInfo from "./admin/pages/admin/AdminInfo";
import AdminLogin from "./admin/pages/admin/AdminLogin";
import AdminProPolkPage from "./admin/pages/admin/AdminProPolk";
import AdminProducts from "./admin/pages/admin/AdminShopPage";
import AdminVideos from "./admin/pages/admin/AdminVideos";
import AuthRoute from "./admin/pages/admin/AuthRoute";
import AdminPatronat from "./admin/pages/patronat/AdminPatronat";
import { loadAdvantages } from "./backend/advantage/advantage";
import { loadBattleHistory } from "./backend/history/history";
import { loadSocialMedia } from "./backend/socialMedia/socialMedia";
import { loadVideos } from "./backend/video/video";
import Menu from "./components/Menu";
import ScrollUpButton from "./components/ScrollUpButton";
import LoadingPage from "./pages/LoadingPage/LoadingPage";
import AdminDashboard from "./admin/pages/admin/AdminDashboard";
import { loadSeo } from "./backend/seo/seo";
import AdminWeekends from "./admin/pages/weekend/AdminWeekends";
import { loadAllWeekends, type Weekend } from "./backend/weekends/weekend";

// ─── Header wrapper ────────────────────────────────────────────────────────────
const HeaderWrapper = () => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const moveBigPhoto = useMediaQuery({ query: `(max-width: 850px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  if (location.pathname.startsWith("/patronat"))
    return (
      <>
        {showMenu && <ServiceMenu onClose={() => setShowMenu(false)} />}
        <ServiceHeader
          onChangeMenu={(value) => setShowMenu(value)}
          isMenuOpen_base={showMenu}
        />
      </>
    );

  if (location.pathname.startsWith("/infoplace")) return <></>;

  return (
    <>
      {showMenu && <Menu onClose={() => setShowMenu(false)} />}
      <div
        style={{
          position:
            moveBigPhoto || location.pathname !== "/"
              ? "fixed"
              : lastScrollY > window.innerHeight * 0.5
                ? "fixed"
                : "absolute",
          height: "var(--header-height)",
          width: "100%",
          transform:
            moveBigPhoto || location.pathname !== "/"
              ? "translateY(-100%)"
              : lastScrollY < window.innerHeight * 0.3
                ? "translateY(-100%)"
                : lastScrollY < window.innerHeight * 0.9
                  ? "translateY(-200%)"
                  : "translateY(-100%)",
          zIndex: showMenu && isMobile ? 10000 : 500,
          transition: lastScrollY < window.innerHeight * 0.5 ? "all 0s linear" : "all 0.3s linear",
        }}
      >
        <Header
          onChangeMenu={(value) => setShowMenu(value)}
          isMenuOpen_base={showMenu}
        />
      </div>
      <div style={{ marginBottom: "var(--header-height)" }} />
    </>
  );
};

// ─── Footer wrapper ────────────────────────────────────────────────────────────
const FooterWrapper = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/test-weekend") || location.pathname.startsWith("/vyshkil-nrk"))
    return <LandingFooter />;
  if (location.pathname.startsWith("/infoplace")) return <></>;
  if (location.pathname.startsWith("/patronat")) return <ServiceFooter />;
  return <Footer />;
};

// ─── App ───────────────────────────────────────────────────────────────────────
const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Store weekends in React state so the route tree re-renders once they load
  const [weekends, setWeekends] = useState<Weekend[]>([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setIsLoading(true);
        await Promise.all([
          loadPatronat(),
          loadBattleHistory(),
          loadSocialMedia(),
          loadVideos(),
          loadAdvantages(),
          loadProducts(),
          loadPatronatInfo(),
          loadMainInfo(),
          loadHowToHelp(),
          loadProPolk(),
          loadSeo(),
          // loadAllWeekends resolves last; we capture the return value into state
          loadAllWeekends().then((list) => {
            setWeekends(list.filter((w) => w.status === "active"));
          }),
        ]);
      } catch (err: any) {
        console.error("Failed to load:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, []);

  if (isLoading) return <LoadingPage />;

  return (
    <Router>
      <img
        src={"/210-sign.svg"}
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          opacity: 0.001,
          userSelect: "none",
          pointerEvents: "none",
          zIndex: "999999",
        }}
        alt="210-logo"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <HeaderWrapper />
      <ScrollUpButton />
      <Routes>
        <Route path="/infoplace/login" element={<AdminLogin />} />

        <Route path="/infoplace" element={<AuthRoute />}>
          <Route path="" element={<Navigate to="/infoplace/dashboard/anketa" replace />} />
          <Route path="dashboard" element={<AdminDashboard />}>
            <Route path="" element={<Navigate to="/infoplace/dashboard/anketa" replace />} />
            <Route path="anketa" element={<AdminAnketa />} />
            <Route path="advantages" element={<AdminAdvantage />} />
            <Route path="battle-history" element={<AdminBattleHistory />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="shop" element={<AdminProducts />} />
            <Route path="info" element={<AdminInfo />} />
            <Route path="how-to-help" element={<AdminHowToHelp />} />
            <Route path="pro-polk" element={<AdminProPolkPage />} />
            <Route path="change-password" element={<AdminChangePassword />} />
            <Route path="patronat" element={<AdminPatronat />} />
            <Route path="weekend" element={<AdminWeekends />} />
          </Route>
        </Route>

        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />

        {/* Dynamic weekend routes — rendered only after loadAllWeekends resolves */}
        {weekends.map((weekend) => (
          <Route
            key={weekend.id}
            path={`/${weekend.slug}`}
            element={<LandingPage weekendId={weekend.id} />}
          />
        ))}

        <Route path="/pro_polk" element={<AboutUsPage />} />
        <Route path="/patronat" element={<ServicePage />} />
        <Route path="/anketa" element={<SignUpPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <FooterWrapper />
    </Router>
  );
};

// ─── Error page ────────────────────────────────────────────────────────────────
const ErrorPage = () => {
  const isSmall = useMediaQuery({ query: "(max-width: 600px)" });
  return (
    <div
      style={{
        width: "100%",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <p
        style={{
          fontSize: isSmall ? "3rem" : "4rem",
          textAlign: "center",
          marginBottom: isSmall ? "3rem" : "5rem",
        }}
      >
        Упс... Сторінку не знайдено
      </p>
      <Button
        text={"НА ГОЛОВНУ"}
        internal_link="/"
        textColor="var(--black)"
        border="2px solid var(--black)"
        hoverBackgroundColor="black"
        hoverTextColor="var(--white)"
        fontFamily="UAFSans-Book"
        containerProps={{ width: "min(22rem, 60vw)" }}
        padding={isSmall ? "0.5rem 0rem" : "0.75rem 0rem"}
        fontSize={isSmall ? "min(7vw, 2.5rem)" : "2.5rem"}
      />
    </div>
  );
};

export default App;